<template>
  <v-app>
    <global-snackbar />
    <mark-loading /> 
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { getGlobalConfig } from '@/api/apiService';
import GlobalSnackbar from '@/components/GlobalSnackbar.vue';
import MarkLoading from '@/components/MarkLoading.vue';
export default {
  name: 'App',
  components: {
    GlobalSnackbar,
    MarkLoading
  },
  async mounted() {
    // localStorage.removeItem("targetNetwork");
    this.$toast.showMarkLoading();
    const config = await getGlobalConfig();
    this.$store.dispatch('setGlobalConfig', config);
    this.$toast.hideMarkLoading();
    this.$eventBus.on('user-logout', () => {
      console.log("user-logout");
      this.$store.dispatch('logout');
      this.$router.push('/');
    });
  }
}
</script>
<style scoped>
</style>